/**
 * Controlled vocabularies for the V3 product catalogue.
 *
 * These mirror the frozen arrays in the inventory service's ProductModelV3
 * exactly, including spelling and case: the backend matches input
 * case-insensitively but persists the canonical spelling from its own list, so
 * sending a value from here stores it unchanged.
 */

export const CLASSIFICATION_TYPES = ["MEDICINE", "NON_MEDICINE"] as const;

export const PRODUCT_STATUSES = ["Live", "UnClassified"] as const;

export const ROUTES = [
  "Oral",
  "Sublingual",
  "Buccal",
  "Topical",
  "Ophthalmic",
  "Otic",
  "Nasal",
  "Inhalation",
  "IV",
  "IM",
  "SC",
  "IV/IM",
  "Intradermal",
  "Rectal",
  "Vaginal",
  "Transdermal",
] as const;

export const RELEASE_TYPES = [
  "IR",
  "SR",
  "ER",
  "CR",
  "XR",
  "MR",
  "PR",
  "DR",
  "XL",
  "Chrono",
  "Retard",
  "N.A.",
] as const;

export const DISINTEGRATION_TYPES = ["MD/ODT", "DT", "N.A."] as const;

export const STRENGTH_UNITS = [
  "mg",
  "mcg",
  "g",
  "IU",
  "%",
  "mEq",
  "mmol",
  "CFU",
] as const;

export const STRENGTH_BASIS_UNITS = [
  "Tablet",
  "Capsule",
  "ml",
  "g",
  "Vial",
  "Ampoule",
  "Dose",
  "Sachet",
  "Respule",
  "Suppository",
  "Pessary",
  "Patch",
  "Lozenge",
  "Syringe",
  "w/w",
  "w/v",
  "v/v",
  "N.A.",
] as const;

export const PACK_UNITS = [
  "Strip",
  "Bottle",
  "Tube",
  "Jar",
  "Box",
  "Sachet",
  "Pouch",
  "Packet",
  "Tin/Can",
  "Vial",
  "Ampoule",
  "Pen/Cartridge",
  "IV Bottle/Bag",
  "Roll",
  "Piece",
  "Pair",
  "Kit",
  "Prefilled Syringe",
] as const;

export const BASE_UNITS = [
  "Tablet",
  "Capsule",
  "ml",
  "g",
  "Piece",
  "Sachet",
  "Dose",
  "Vial",
  "Ampoule",
  "Respule",
  "Suppository",
  "Pessary",
  "Patch",
  "Lozenge",
  "Pair",
  "Kit",
  "Syringe",
] as const;

export const STORAGE_CONDITIONS = [
  "Room Temperature (below 30°C)",
  "Cool Place (below 25°C)",
  "Refrigerated (2-8°C)",
  "Frozen (below -15°C)",
] as const;

/** product_attributes.target_group - free text on the column, listed for the picker. */
export const TARGET_GROUPS = [
  "Infant",
  "Child",
  "Teen",
  "Adult",
  "Senior",
  "Men",
  "Women",
  "Pregnant",
  "Lactating",
  "All",
] as const;

/** product_attributes.diet_type */
export const DIET_TYPES = [
  "Vegetarian",
  "Non-Vegetarian",
  "Vegan",
  "Eggetarian",
] as const;

/** product_attributes.sugar_status */
export const SUGAR_STATUSES = [
  "Sugar Free",
  "Contains Sugar",
  "Low Sugar",
  "No Added Sugar",
] as const;

/** medicine_salt_dtls.concentration_basis */
export const CONCENTRATION_BASES = ["w/w", "w/v", "v/v"] as const;

/** Shared Tailwind classes so every catalogue form looks the same. */
export const formStyles = {
  lableStyle: "block text-sm text-[#3F5260] font-medium mb-1",
  inputStyle:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm disabled:bg-gray-50 disabled:text-gray-500",
  sectionTitle: "text-sm font-semibold text-gray-800",
  sectionCard: "border border-[#E5E7EB] rounded-xl p-4 bg-white",
};
